export default {
  API_URL: 'https://api.onde-encontrar.ceramicaderosso.com.br/',
};
